import type { AdminNavItem, AdminNavSection } from '../types/admin';

/** Menu latéral admin Academia — regroupé par utilité métier. */
export const ADMIN_NAV_SECTIONS: AdminNavSection[] = [
  {
    id: 'pilotage',
    label: 'Vue d’ensemble',
    items: [{ id: 'dashboard', label: 'Tableau de bord', icon: 'dashboard', path: '/admin/dashboard' }],
  },
  {
    id: 'finances',
    label: 'Inscriptions & finances',
    items: [
      { id: 'inscriptions', label: 'Inscriptions', icon: 'assignment', path: '/admin/inscriptions' },
      { id: 'paiements', label: 'Paiements', icon: 'account_balance', path: '/admin/paiements' },
      { id: 'tarifs', label: 'Tarification', icon: 'payments', path: '/admin/tarifs' },
      { id: 'wallet', label: 'Portefeuilles', icon: 'account_balance_wallet', path: '/admin/wallet' },
      { id: 'parrainage', label: 'Parrainage', icon: 'groups', path: '/admin/parrainage' },
    ],
  },
  {
    id: 'pedagogie',
    label: 'Formation & pédagogie',
    items: [
      { id: 'apprenants', label: 'Apprenants', icon: 'group', path: '/admin/apprenants' },
      {
        id: 'activites-apprenants',
        label: 'Activités apprenants',
        icon: 'history',
        path: '/admin/activites-apprenants',
      },
      { id: 'formations', label: 'Formations', icon: 'school', path: '/admin/formations' },
      { id: 'planning', label: 'Planning', icon: 'calendar_month', path: '/admin/planning' },
      {
        id: 'charge-horaire',
        label: 'Charge horaire',
        icon: 'event',
        path: '/admin/charge-horaire',
      },
      { id: 'formateurs', label: 'Formateurs', icon: 'cast_for_education', path: '/admin/formateurs' },
      {
        id: 'activites-formateurs',
        label: 'Activités formateurs',
        icon: 'history',
        path: '/admin/activites-formateurs',
      },
      { id: 'ambassadeurs', label: 'Ambassadeurs', icon: 'campaign', path: '/admin/ambassadeurs' },
      {
        id: 'activites-ambassadeurs',
        label: 'Activités ambassadeurs',
        icon: 'history',
        path: '/admin/activites-ambassadeurs',
      },
      { id: 'academique', label: 'Académique', icon: 'menu_book', path: '/admin/academique' },
      { id: 'elearning', label: 'E-learning', icon: 'play_circle', path: '/admin/elearning' },
      { id: 'excellence', label: 'Excellence', icon: 'emoji_events', path: '/admin/excellence' },
      { id: 'documents', label: 'Dossiers', icon: 'folder_shared', path: '/admin/documents' },
    ],
  },
  {
    id: 'operations',
    label: 'Services & communication',
    items: [
      { id: 'logistique', label: 'Logistique', icon: 'inventory_2', path: '/admin/logistique' },
      { id: 'communication', label: 'Communication', icon: 'notifications_active', path: '/admin/communication' },
    ],
  },
  {
    id: 'gouvernance',
    label: 'Plateforme & gouvernance',
    items: [
      { id: 'parametres-app', label: 'Paramètres', icon: 'tune', path: '/admin/parametres-app' },
      { id: 'site', label: 'Site & QR', icon: 'public', path: '/admin/site' },
      {
        id: 'partenaires-sponsors',
        label: 'Partenariat',
        icon: 'handshake',
        path: '/admin/partenaires-sponsors',
      },
      { id: 'security', label: 'Sécurité', icon: 'shield', path: '/admin/security' },
      { id: 'corbeille', label: 'Corbeille', icon: 'delete_forever', path: '/admin/corbeille' },
      { id: 'equipe', label: 'Équipe & accès', icon: 'manage_accounts', path: '/admin/equipe' },
    ],
  },
];

/** Liste à plat (recherche, tests, compatibilité). */
export function flattenAdminNavSections(sections: AdminNavSection[]): AdminNavItem[] {
  return sections.flatMap((section) => section.items);
}
